import {
	matchPath,
} from 'react-router-dom'

import {
	HIDDEN_PAGES,
} from '../config'

export const shouldShowPageHeader = (pathname: string): boolean => {
	return !HIDDEN_PAGES.some((pattern) => {
		return matchPath(pattern, pathname)
	})
}
